

export function getApiDomain(){
  return "https://api.boquanqiu.cn"
}

export async function handleError(err) {
    return new Response(JSON.stringify({
        code: 400,
        message: 'Stupid network Error'
    }));
};

export async function writelog(action,result,comment){ 

  var uid = getLocalUsrInfo().UserID
  if(uid == "") {
    uid = "guest"
  }
  window.sendLog(uid,{action:action,comment:comment,result:result})
  fetch(getApiDomain()+'/log?from=chrome&action='+action+'&result='+result+'&comment='+encodeURIComponent(JSON.stringify(comment))+'&product=onlinepay&rnd='+(Math.random()*100).toString()).catch(handleError);
  
}

export function getVipAwd(){
    var vipAwd = [
        {
          count:20,
          rate:1.1
        },
        {
          count:35,
          rate:1.15
        },
        {
          count:50,
          rate:1.2
        },
        {
          count:150,
          rate:1.4
        },
        {
          count:200,
          rate:1.5
        },
        {
          count:250,
          rate:1.7
        },
        {
          count:300,
          rate:1.9
        }
      ]
    return vipAwd
}

export function svipAwd(){
    var svipAwd = [
        {
          count:20,
          rate:1.2
        },
        {
          count:95,
          rate:1.3
        },
        {
          count:145,
          rate:1.4
        },
        {
          count:200,
          rate:1.6
        },
        {
          count:250,
          rate:1.8
        },
        {
          count:300,
          rate:2.2
        }
      ]
    return svipAwd  
}


export function setLocalUsrInfo(usr){
    localStorage.setItem("usr",JSON.stringify(usr))
  }

export function  getLocalUsrInfo(){
    var usr = JSON.parse(localStorage.getItem("usr"))
    if(usr != undefined && usr.UserID != "" && usr.SessionID != ""){
      return usr
    }
    usr = {
      UserID:"",
      SessionID:"",
      UserName:"",
      VIP:1, //0:normal 1:vip 2:svip
      LeftLiveTime:"0", //hour
      RunJob:null,
      ChargeMode:0,
      SubPlan:"$9.98/month",
      PushSvr:"",
      PushCode:""
    }
    localStorage.setItem("usr",JSON.stringify(usr))
    return usr 
  }